"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tileDataService = exports.TileDataService = void 0;
const __1 = require("..");
const app_1 = require("app");
class TileDataService {
    constructor() {
        this.getTileListData = (items, tileType, selectedFiltersQueryString, dictionary) => {
            return items.map((item, index) => {
                if (!item) {
                    return undefined;
                }
                if (item.id == null) {
                    item.id = index.toString();
                }
                item.hasCardHoverEffect = true;
                item = this.addFilterUrlToItemLink(item, selectedFiltersQueryString);
                let itemType = tileType;
                if (itemType === __1.TileTypeEnum.SearchResults) {
                    item = this.processSearchResultsItem(item);
                    itemType =
                        item.type && __1.TileTypeFromString[item.type]
                            ? __1.TileTypeFromString[item.type]
                            : item.pageType && this.getTileTypeFromPageType(item.pageType);
                    item.pageType = 'SearchResults';
                    item.tileType = itemType;
                }
                return this.getTileDataByType(itemType, item, dictionary);
            });
        };
        this.processSearchResultsItem = (item) => {
            let result = item;
            result.type = this.capitalize(result.type);
            result.pageType = this.capitalize(result.pageType);
            result.image =
                result.image && result.image.trim() ? result.image : this.getImagesSupported(result);
            // Get Text from HTMLString
            result.title = (0, __1.TextFromHTMLString)(result.title);
            return result;
        };
        this.getTileDataByType = (type, item, dictionary) => {
            var _a;
            switch (type) {
                case __1.TileTypeEnum.Article:
                    item.tag = this.getTags(item, ['startDate', 'segments']);
                    break;
                case __1.TileTypeEnum.Document: // Documentation & Drawings
                    if (item.downloadUrls && item.downloadUrls.length > 1) {
                        // Drawings with Table
                        item.hasCardHoverEffect = false;
                        item.link = { url: '' };
                        break;
                    }
                    if (item.downloadUrls && item.downloadUrls.length === 1) {
                        item.link = { url: (_a = item.downloadUrls[0]) === null || _a === void 0 ? void 0 : _a.url };
                    }
                    const tagsArray = [];
                    item.isDocument = true;
                    !!item.documentType && tagsArray.push(item.documentType);
                    !!item.drawingType && tagsArray.push(item.drawingType);
                    this.getLanguageTag(item, tagsArray, dictionary);
                    !!item.fileType && tagsArray.push(item.fileType);
                    !!item.fileSize && tagsArray.push((0, __1.FormatBytes)(item.fileSize));
                    !!item.link && (item.link.newWindow = true);
                    !!item.lastModifiedDate &&
                        tagsArray.push(this.createDateString(dictionary.updated, item.lastModifiedDate));
                    !!item.expireDate &&
                        tagsArray.push(this.createDateString(dictionary.expireDate, item.expireDate));
                    !!item.authority && tagsArray.push(item.authority);
                    item.archived && !!dictionary.archived && tagsArray.push(dictionary.archived);
                    if (item.isGlobal || (item.validFor && item.validFor.length)) {
                        item = Object.assign(Object.assign({}, item), { validForLabel: dictionary.validForLabel, multipleLabel: dictionary.multipleLabel, globalTooltipMessage: dictionary.globalTooltipMessage, multipleTooltipMessage: dictionary.multipleTooltipMessage });
                    }
                    item.tag = tagsArray.join(' | ');
                    break;
                case __1.TileTypeEnum.Careers: // Career
                    item.tag = this.getTags(item, ['date', 'location']);
                    item.isExternalLink = true;
                    break;
                case __1.TileTypeEnum.Course: // Course Page
                    item.tag = this.getTags(item, ['segments']);
                    if (item.pageType === 'SearchResults') {
                        item.isExternalLink = true;
                    }
                    break;
                case __1.TileTypeEnum.Download: // Download Page
                    this.getAssetTypeSoftware(item, dictionary);
                    break;
                case __1.TileTypeEnum.Product:
                case __1.TileTypeEnum.TileGroupContent:
                    item.tag = this.getTags(item, ['segments', 'downloadTypes']);
                    const hasMultipleLinks = item.isInformationObject && (item === null || item === void 0 ? void 0 : item.link) && (item === null || item === void 0 ? void 0 : item.storeLink) && (item === null || item === void 0 ? void 0 : item.documentsLink);
                    if (hasMultipleLinks) {
                        item.multipleLinks = [
                            Object.assign(Object.assign({}, item.link), { caption: dictionary === null || dictionary === void 0 ? void 0 : dictionary.learnMore }),
                            Object.assign(Object.assign({}, item.storeLink), { caption: dictionary === null || dictionary === void 0 ? void 0 : dictionary.storeLinkTitle }),
                            Object.assign(Object.assign({}, item.documentsLink), { caption: dictionary === null || dictionary === void 0 ? void 0 : dictionary.documentsLinkTitle }),
                        ];
                        item.hasCardHoverEffect = false;
                        item.link = { url: '' };
                    }
                    break;
                case __1.TileTypeEnum.SabaCourses: {
                    // Recommended Courses
                    const newItem = {
                        id: `${item.title}${item.deepLinks[0]}`,
                        title: item.title,
                        description: (0, app_1.processCourseDescription)(item.description),
                        image: item.imageUrl,
                        imageAltText: item.title,
                        isExternalLink: false,
                        isPageWithFilters: false,
                        link: { url: '' },
                        buttonLink: { url: item.deepLinks[0], newWindow: true },
                        hasCardHoverEffect: false,
                    };
                    item = newItem;
                    break;
                }
                case __1.TileTypeEnum.OtherContent:
                    const newItem = {
                        description: item.description,
                        details: item.details,
                        id: item.id,
                        image: null,
                        imageAltText: null,
                        isExternalLink: item.isExternalLink,
                        isPageWithFilters: item.isPageWithFilters,
                        link: item.link,
                        showUrl: true,
                        title: item.title,
                    };
                    item = Object.assign(Object.assign({}, item), newItem);
                    break;
            }
            return item;
        };
        this.getTileTypeFromPageType = (pageType) => {
            return __1.TileTypeFromString[pageType] ? __1.TileTypeFromString[pageType] : __1.TileTypeEnum.OtherContent;
        };
        this.getImagesSupported = (item) => {
            return item.images && item.images.length ? this.getFirstSupportedImage(item.images) : null;
        };
        this.getAssetTypeSoftware = (item, dictionary) => {
            if (item.assetType === 'software') {
                const documentType = this.getSoftwareDocumentType(item);
                item.documentType = documentType;
                item.tag = this.getSoftwareTags(item, dictionary, documentType);
            }
            else {
                item.tag = this.getTags(item, ['segments', 'softwareTypes']);
            }
            return item;
        };
        this.getLanguageTag = (item, tagsArray, dictionary) => {
            if (!(!item.language || (item.language && !item.language.length)) && item.language.length > 1) {
                tagsArray.push(dictionary.multilanguage);
            }
            else {
                tagsArray.push(item.language[0]);
            }
            return tagsArray;
        };
        this.getFirstSupportedImage = (images) => {
            const pattern = /(.+)\.(jpg|jpeg|png|gif)$/i;
            for (const image of images) {
                if (pattern.test(image))
                    return image;
            }
            return null;
        };
        this.getTags = (item, fields = []) => fields
            .reduce((acc, field) => {
            if (!!item[field] && item[field].length) {
                Array.isArray(item[field]) ? acc.push(item[field].join(' | ')) : acc.push(item[field]);
            }
            return acc;
        }, [])
            .join(' | ');
        this.getSoftwareDocumentType = (item) => {
            if (Array.isArray(item.softwareTypes) && !!item.softwareTypes[0]) {
                return item.softwareTypes[0];
            }
        };
        this.getSoftwareTags = (item, dictionary, documentType) => {
            const tagsArray = [];
            const dotBeforeNameRegExp = /^\./;
            item.isSoftware = true;
            !!documentType && tagsArray.push(documentType);
            !!item.segments.length && tagsArray.push(item.segments);
            !!item.softwareCharacteristic && tagsArray.push(item.softwareCharacteristic);
            !!item.softwareVersion &&
                tagsArray.push(this.createDateString(dictionary.version, item.softwareVersion));
            !!item.fileType &&
                tagsArray.push(dotBeforeNameRegExp.test(item.fileType) ? item.fileType : `.${item.fileType}`);
            !!item.fileSize && tagsArray.push((0, __1.FormatBytes)(item.fileSize));
            !!item.softwareReleaseDate &&
                tagsArray.push(this.createDateString(dictionary.softwareReleaseDate, item.softwareReleaseDate));
            return tagsArray.join(' | ');
        };
        this.createDateString = (dateLabel, dateValue) => dateLabel ? `${dateLabel}: ${dateValue}` : dateValue;
        this.capitalize = (str) => {
            return str && str.length > 1 ? (0, app_1.capitalizeFirstLetter)(str) : str;
        };
    }
    addFilterUrlToItemLink(item, filterUrl) {
        if (!filterUrl) {
            return item;
        }
        const link = item.isPageWithFilters
            ? {
                newWindow: item.link.newWindow,
                url: item.link.url + filterUrl,
            }
            : item.link;
        return Object.assign(Object.assign({}, item), { link });
    }
}
exports.TileDataService = TileDataService;
exports.tileDataService = new TileDataService();
